import { CampagneSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const CampagneModel: SelectorModel = {
  name: 'campagnes',
  getSelector: CampagneSelectors.selectAllCampagnesDictionary,
  isReady: CampagneSelectors.selectIsReadyCampagne
};
